import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCreditCard } from '@fortawesome/free-solid-svg-icons';
import { SubscriptionSummary } from '../services/accountService';

interface PaymentRequiredBannerProps {
  summary: SubscriptionSummary | null;
}

const PaymentRequiredBanner: React.FC<PaymentRequiredBannerProps> = ({ summary }) => {
  if (!summary?.access?.showPaymentBanner || summary.exemptFromLimits) {
    return null;
  }

  const phase = summary.access.phase;
  const renewUrl =
    (process.env.REACT_APP_RENEWAL_URL || '').trim() ||
    'https://wheretoinvest.io/upgrade';

  const daysLeft =
    phase === 'grace'
      ? summary.access.daysUntilSoftLock
      : summary.access.daysUntilBillingEnd;

  let title = 'Payment required';
  let message =
    'Renew your plan to keep full access to reports, downloads, and saved history. Training stays available.';

  if (phase === 'grace') {
    title = 'Your plan has ended — grace access is active';
    message =
      daysLeft !== null && daysLeft !== undefined
        ? `You still have full access for about ${daysLeft} more day${daysLeft === 1 ? '' : 's'}. Renew now to avoid pausing paid features.`
        : 'You still have a short grace window with full access. Renew now to keep reports and history available.';
  } else if (phase === 'soft_locked') {
    title = 'Paid features are paused';
    message =
      'Your grace period has ended. You can still sign in and use Training. Renew to restore reports, downloads, saves, and history.';
  }

  return (
    <section className="dashboard-payment-banner" aria-label="Payment reminder">
      <div className="dashboard-payment-banner__content">
        <FontAwesomeIcon icon={faCreditCard} className="dashboard-payment-banner__icon" />
        <div>
          <strong>{title}</strong>
          <p>{message}</p>
        </div>
      </div>
      <a
        className="btn btn-primary btn-sm"
        href={renewUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        Renew / pay now
      </a>
    </section>
  );
};

export default PaymentRequiredBanner;
